import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-detail-container" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "id-box" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "cumulative-item first" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "cumulative-item" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "cumulative-item" }
const _hoisted_10 = { class: "value" }

import Icon from '../../../../common/Icon.vue'
import copy from '../../../../../assets/icon/copy.svg';
import { TUIGlobal } from '@tencentcloud/universal-api';
import { transformTextWithKeysToEmojiNames } from '../../../emoji-config';
import { isUniFrameWork } from '../../../../../utils/env';
import { Toast } from '@/TUIKit/components/common/Toast/index';
// uni-app conditional compilation will not run the following code
// #ifndef APP || APP-PLUS || MP || H5
import CopyManager from '../../../utils/copy';
import { onMounted, ref, watchEffect } from 'vue';
import { queryUserProductApi } from '@/utils/user';
// #endif


export default /*@__PURE__*/_defineComponent({
  __name: 'user-detail',
  props: {
  userDetail: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {

async function copyMessage() {
  if (isUniFrameWork) {
    TUIGlobal?.setClipboardData({
      data: transformTextWithKeysToEmojiNames(props.userDetail.id),
    });
  } else {
    // uni-app conditional compilation will not run the following code
    // #ifndef APP || APP-PLUS || MP || H5
    CopyManager.copySelection(props.userDetail.id);
    // #endif
  }
  Toast({
      message: '复制成功',
      type: 'success',
    });
}

const props = __props

const productStr = ref('')

const getProduct = async ()=>{
  try {
		const res = await queryUserProductApi({customerId: props.userDetail.id})
		const result =  res?.body?.list || []

    if(result.length){
      productStr.value = result?.map((item:any) => item.name).join('、') 
    }
	} catch (err:any) {
		console.log(err);
	}
}


watchEffect(() => {
  if(props.userDetail.id){
    getProduct()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text" }, "用户ID:", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(__props.userDetail.id), 1),
          _createVNode(Icon, {
            file: _unref(copy),
            class: "icon",
            onClick: copyMessage,
            width: '18px',
            height: '18px'
          }, null, 8, ["file"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text" }, "累计打卡天数:", -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.userDetail.cumulativeClockinCount || 0), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text" }, "连续打卡天数:", -1)),
        _createElementVNode("span", _hoisted_8, _toDisplayString(__props.userDetail.singinNum || 0), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text" }, "使用药品:", -1)),
      _createElementVNode("span", _hoisted_10, _toDisplayString(productStr.value || '/'), 1)
    ])
  ]))
}
}

})